import React from 'react';
import * as types from '../../../redux/futures/store/types';
import storeActions from '../../../redux/futures/store/actions';
import _ from 'lodash';
import { connect } from 'react-redux';
import Input from '../../../components/Input';
import baseHelper from '../../../helpers/BaseHelper';
import appConst from '../../../config/const';
import CustomDatePicker from "../../../components/DatePicker/CustomDatePicker";



class Cancel extends React.Component {

    constructor(props) {
        super(props);
        const date = new Date();
        this.state = {
            store: {
                store_id: '',
                fullname: '',
                ladi_uid: '',
                _id: '',
                email: '',
                pkg_name: '',
                pkg_exp: '',
                pkg_buy_exp: '',
                pkg_buy_price: '0',
                created_at: '',
                web_id: ''
            },
            userinfo: {
                point: '',
                email: '',
                fullname: '',
                lastname: '',
                phone: ''
            },
            currentOrder: {
                _id: '',
                reference_no: '',

            },
            exprireDate: date,
            activedDate: date,
            type: props.typeUpgrade,
            note: '',
            affilateCode: '',
            appCode: 'LP',
            packages: [],
            selectedPackage: '',
            month: "3",
            addition_month: "0",
            discount: "0",
            point: "0",
            totalPrice: 0,
            backMoney: 0,
            method: appConst.PAYMENT_STATUS_OPTIONS.PAID.value,
            returned: appConst.PAYMENT_RETURN_OPTIONS.RETURNED.value,
            loading: false,
            loaderPackages: true,
            classNormal: "ladiui button primary",
            classLoading: "ladiui loader button primary",
            classApply: "ladiui button primary"
        }
        this.initialState = _.cloneDeep(this.state);
        this.inputsRef = new Set();

        this.ref = React.createRef();

    }

    componentWillReceiveProps(nextProps) {

        if (this.props.currentOrder !== nextProps.currentOrder) {
            this.setState({
                currentOrder: nextProps.currentOrder
            })
        }
        if (this.props.currentStore !== nextProps.currentStore) {
            this.setState({
                currentStore: nextProps.currentStore
            })
        }
        if (this.props.currentStore !== nextProps.currentStore) {
            // console.log('nextProps.currentStore ', nextProps.currentStore);
            let { pkg_actived_at, pkg_exp, pkg_name, created_at } = nextProps.currentStore;
            if (!pkg_actived_at) {
                pkg_actived_at = new Date();
            } else {
                pkg_actived_at = new Date(pkg_actived_at);
            }
            if (!pkg_exp) {
                pkg_exp = new Date();
            } else {
                pkg_exp = new Date(pkg_exp);
            }
            this.setState({
                store: _.pick(nextProps.currentStore, _.keys(this.state.store)),
                appCode: nextProps.appCode,
                loaderPackages: true,
                activedDate: pkg_actived_at,
                exprireDate: pkg_exp,
                packages: [],
                pkg_name: pkg_name
            })

        }

        if (nextProps.action === types.LIST_PACKAGE) {
            this.setState({ loaderPackages: false });
            if (nextProps.status && nextProps.packages.length > 0) {
                const { store } = this.state;
                const expDate = new Date(store.pkg_exp);
                const isExp = baseHelper.diffDateDay(expDate, new Date()) > 0;

                let selectedPackage = null;
                let list = [];
                // window.LadiUI.toastr('success', '', nextProps.message);
                for (let i = 0; i < nextProps.packages.length; i++) {
                    // if (nextProps.packages[i].price == 0) {
                    list.push(nextProps.packages[i]);
                    // }
                }
                // if (price) {
                for (let i = 0; i < list.length; i++) {
                    if (store.pkg_name == list[i].pkg_name) {
                        selectedPackage = list[i];
                        break;
                    }
                }
                // } else {
                // list = nextProps.packages;
                // }

                list = list.sort(function (a, b) {
                    if (a.price > b.price) return 1;
                    if (a.price < b.price) return -1;
                    return 0;
                });
                if (!selectedPackage) {
                    selectedPackage = list[0];
                }
                // console.log(list, selectedPackage);
                this.setState({
                    packages: list,
                    selectedPackage: selectedPackage,
                    loaderPackages: false
                });
            } else {
                window.LadiUI.toastr('error', '', nextProps.message);
            }

            // this.list();
        }
        if (nextProps.action == types.CHANGE_PACKAGE_STORE) {
            this.setState({
                loading: false,
                classApply: this.state.classNormal
            });
            if (nextProps.status) {
                const _seft = this;
                window.LadiUI.toastr('success', '', nextProps.message);
                setTimeout(function () {
                    window.LadiUI.closeModal(_seft.ref.current);
                }, 1000);

            } else {
                window.LadiUI.toastr('error', '', nextProps.message);
            }
        }

    }

    pickPackages(id) {
        const { packages } = this.state;
        // console.log('packages:', packages);
        for (let i = 0; i < packages.length; i++) {
            if (packages[i].id === id) {

                this.setState({
                    selectedPackage: packages[i]
                });
                break;
            }
        }

    }

    resetForm = (event) => {
        // console.log('===resetForm===');
        if (event && event.target && !event.target.hasAttribute("data-dismiss")) {
            return;
        }


        this.setState({
            ..._.cloneDeep(this.initialState)
        })
    }


    changeActivedate = (date) => {
        this.setState({
            activedDate: date
        }, () => {
            // this.getList();
        });

    }

    changeExpriredate = (date) => {
        this.setState({
            exprireDate: date
        }, () => {
            // this.getList();
        });

    }


    submit = () => {
        // Validate  
        let errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, ref => {
            if (ref.validate) {
                errors = errors.concat(ref.validate());
            }
        });

        _.compact(errors);
        if (errors.length > 0) {
            const errorMessage = errors.join("<br/>");
            window.LadiUI.toastr('error', '', errorMessage);
            return;
        }

        const { store, selectedPackage, activedDate, exprireDate, appCode, currentOrder, note } = this.state;

        const data = {
            ladi_uid: store._id,
            reference_no: currentOrder.reference_no,
            pkg_name: selectedPackage.pkg_name,
            pkg_actived_at: activedDate,
            pkg_exp: exprireDate,
            note: note
        };

        // console.log(data); return;
        this.props.changePackageStore(data);
        this.state.loading = true;
        this.state.classApply = this.state.classLoading;
    }


    onChangePackage = (event) => {
        this.pickPackages(event.target.value);
    }

    onChangeTextArea = (event) => {

        this.setState({
            note: event.target.value

        });
    }


    handleClickOutside = () => {
        this.props.onCancel();
    }

    render() {
        this.inputsRef = new Set();
        const { store, packages, selectedPackage, loaderPackages, userinfo, backMoney, currentOrder } = this.state;
        let title = "Hủy đơn hàng: " + currentOrder.reference_no;
        if (userinfo.is_partner_aff) {
            title += " - Mã Partner : " + userinfo.affilate_code;
        }
        let appName = appConst.STORE_CONFIG.APP_CODE.LP.name;
        return (
            <div ref={this.ref} id="modal-cancel-order" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-cancel-order" style={{ zIndex: 21 }} >
                <div className={`ladiui-modal-content ${loaderPackages ? 'loader' : ''}`} >
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-cancel-order"><i className="ladi-icon icon-e-remove" data-dismiss="modal-cancel-order" onClick={this.props.onCancel} /></button>
                        <h3>{title}<span className="app-name">{appName}</span> {store.email} </h3>
                    </div>
                    <div className={"ladiui-modal-body"}>

                        <div className="ladiui-row" >
                            <div className="col-50" style={{ height: "40px" }} >
                                <strong>Tên store: </strong>
                                {
                                    store.fullname
                                }
                            </div>


                            <div className="col-50" style={{ height: "40px" }}>
                                <strong>Ladi UID: </strong>
                                {
                                    store._id
                                }
                            </div>
                        </div>
                        <div className="ladiui-row"  >
                            <div className="col-50" style={{ height: "40px" }}>
                                <strong>Tên gói: </strong>{store.pkg_name}
                            </div>
                            <div className="col-50" style={{ height: "40px" }}>
                                <strong>Ngày hết hạn: </strong>{baseHelper.formatStrToDate(store.pkg_exp)}
                                {' (' + baseHelper.numberWithCommas(backMoney) + ')'}
                            </div>
                        </div>
                        <form>

                            <div>
                                <div className="ladiui-row" >
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <h3>Ngày hết hạn</h3>
                                        </div>
                                        <div className="ladiui form-group">
                                            <CustomDatePicker
                                                customClass="ladiui input date"
                                                selected={this.state.exprireDate}
                                                // onSelect={this.handleSelect} //when day is clicked
                                                onChange={this.changeExpriredate} //only when value has changed
                                            />
                                        </div>
                                    </div>
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <h3>Ngày kích hoạt</h3>
                                        </div>
                                        <div className="ladiui form-group">
                                            <CustomDatePicker
                                                customClass="ladiui input date"
                                                selected={this.state.activedDate}
                                                // onSelect={this.handleSelect} //when day is clicked
                                                onChange={this.changeActivedate} //only when value has changed
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="ladiui form-group condition-form">

                                    <h3>Lựa chọn gói dịch vụ</h3>
                                </div>
                                <div className="ladiui-row">
                                    {
                                        _.map(packages, (packageObj, idx) => {
                                            // if (packageObj.price != undefined && packageObj.price == 0) {
                                            //     return <div key={"package-" + packageObj.name}></div>
                                            // }

                                            return <div className="ladiui form-group" style={{ height: "40px" }} key={"package-" + packageObj.name + "-" + idx}>

                                                <input type="radio"

                                                    id={"change-package-" + packageObj.id}
                                                    name="selectedPackage"
                                                    value={packageObj.id}
                                                    onChange={this.onChangePackage}
                                                    // defaultChecked
                                                    checked={selectedPackage.pkg_name == packageObj.pkg_name}
                                                />

                                                <label htmlFor={"change-package-" + packageObj.id}>{packageObj.pkg_display_name}</label>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className="ladiui-row">
                                    <div className="ladiui form-group">
                                        <strong>Ghi chú: </strong>
                                        <textarea name="note" className="ladiui textarea ladi-payment-info"
                                            value={this.state.note} onChange={this.onChangeTextArea} />
                                    </div>
                                </div>
                            </div>
                        </form>

                    </div>
                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="modal-cancel-order"><i className="ladi-icon icon-e-remove" data-dismiss="modal-cancel-order" onClick={this.props.onCancel} />Close</button>
                        <button
                            ref={this.ref}
                            className={this.state.classApply}
                            onClick={this.submit}
                            disabled={this.state.loading}
                        >
                            <i className="ladi-icon icon-floppy-disk" style={{ display: (this.state.loading) ? 'none' : '', paddingRight: '5px' }}></i> Áp dụng </button>

                        {/* {this.props.loading && <Spinner />} */}
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {

        changePackageStore: (store) => dispatch(storeActions.changePackageStore(store)),
    }
}

const mapStateToProps = (state) => ({ ...state.store });

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Cancel);